exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#dv-full-screen-container{position:fixed;top:0;left:0;overflow:hidden;transform-origin:left top;z-index:999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/fullScreenContainer/src/main.css
// module id = 1099
// module chunks = 45